var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.891 3.23419C10.9259 3.26903 10.9536 3.31041 10.9725 3.35597C10.9914 3.40153 11.0011 3.45037 11.0011 3.49969C11.0011 3.54902 10.9914 3.59786 10.9725 3.64342C10.9536 3.68898 10.9259 3.73036 10.891 3.76519L5.64097 9.01519C5.60614 9.05012 5.56476 9.07782 5.5192 9.09673C5.47364 9.11563 5.4248 9.12536 5.37547 9.12536C5.32615 9.12536 5.27731 9.11563 5.23175 9.09673C5.18619 9.07782 5.14481 9.05012 5.10997 9.01519L2.48497 6.39019C2.41456 6.31978 2.375 6.22428 2.375 6.12469C2.375 6.02511 2.41456 5.92961 2.48497 5.85919C2.55539 5.78878 2.65089 5.74922 2.75047 5.74922C2.85006 5.74922 2.94556 5.78878 3.01597 5.85919L5.37547 8.21944L10.36 3.23419C10.3948 3.19927 10.4362 3.17156 10.4817 3.15266C10.5273 3.13375 10.5761 3.12402 10.6255 3.12402C10.6748 3.12402 10.7236 3.13375 10.7692 3.15266C10.8148 3.17156 10.8561 3.19927 10.891 3.23419Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsCheck);
export default __webpack_public_path__ + "static/media/bsCheck.6cd2479300e1ae3c796cfa808cafb110.svg";
export { ForwardRef as ReactComponent };